"use client";

import dataProviderSimpleRest from "@refinedev/simple-rest";


const API_URL = "http://localhost:8000";

export const mockProvider = dataProviderSimpleRest(API_URL);
